import styled from 'styled-components';
import { colours, common } from 'themes/default';

export const StyledTable = styled.table`
  width: 100%;
  height: fit-content;
  padding: 16px;
  box-shadow: 0px 0px 30px ${colours.Greyscale.MistGrey};
`;

export const StyledTableHead = styled.thead`
  th {
    padding: 8px;
    text-align: center;
    background-color: ${common.tables.header.backgroundColour};
    color: ${common.tables.header.fontColour};
  }
`;

export const StyledTableBody = styled.tbody`
  & > tr > td {
    padding: 0;
  }

  & > tr:nth-of-type(even) {
    & > td:first-of-type,
    & > td > div > div {
      background-color: ${common.tables.rowAlternate.backgroundColour};
      color: ${common.tables.rowAlternate.fontColour};
    }
  }

  & > tr:nth-of-type(odd) {
    & > td:first-of-type,
    & > td > div > div {
      background-color: ${common.tables.row.backgroundColour};
      color: ${common.tables.row.fontColour};
    }
  }
`;

export const BodyCell = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  flex: 1;
  gap: 2px;
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  flex: 1;
  align-items: center;
  padding: 6px 4px;
  white-space: nowrap;
`;

export const StyledTableFooter = styled.tfoot`
  td {
    padding: 8px 4px;
    font-weight: bold;
    text-align: end;
    background-color: ${common.tables.footer.backgroundColour};
    color: ${common.tables.footer.fontColour};
  }
`;
